import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * @typedef {Object} ProductMainWsRefs
 * @property {HTMLElement} subCategory
 * @property {HTMLElement} name
 * @property {HTMLElement} description
 * @property {HTMLElement} fitAndFinish
 * @property {HTMLElement} attachmentMethod
 */

/**
 * @extends {Component<ProductMainWsRefs>}
 */
class ProductMainWs extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateMetafields);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateMetafields);
  }

  get variantData() {
    const script = this.querySelector(':scope > script[type="application/json"]');
    return script ? JSON.parse(script.textContent ?? '{}') : {};
  }

  updateMetafields = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const variantId = event.detail.resource?.id;
    if (!variantId) return;

    const metafields = this.variantData[variantId];
    if (!metafields) return;

    const { subCategory, name, description, fitAndFinish, attachmentMethod } = this.refs;

    if (subCategory) subCategory.textContent = metafields.sub_category ?? '';
    if (name) name.textContent = metafields.name || this.dataset.productTitle || '';
    if (description) description.innerHTML = `<div>${metafields.description ?? ''}</div>`;
    if (fitAndFinish) {
      fitAndFinish.textContent = metafields.fit_and_finish ?? '';
      fitAndFinish.parentElement.hidden = !metafields.fit_and_finish;
    }
    if (attachmentMethod) {
      attachmentMethod.textContent = metafields.attachment_method ?? '';
      attachmentMethod.parentElement.hidden = !metafields.attachment_method;
    }
  };
}

if (!customElements.get('product-main-ws')) {
  customElements.define('product-main-ws', ProductMainWs);
}
